import React, { FunctionComponent, memo } from "react";

import { Icon } from "@/components/Icon";
import { Separator } from "@/components/Separator";
import { Text } from "@/components/Text";
import { Flex, IStyleSize, IStyleWeight } from "@/eworkitComponents";
import { TColorVariant } from "@/style/colorVariants";

interface IDetailSectionProps extends Partial<IStyleSize>, Partial<IStyleWeight> {
  label?: string;
  color?: TColorVariant;
  isVisible?: boolean;
  hasSeparator?: boolean;
  className?: string;
  icon?: string;
  iconColor?: TColorVariant;
}

export const DetailSection: FunctionComponent<IDetailSectionProps> = memo(props => {
  const {
    label,
    children,
    isVisible = true,
    hasSeparator = false,
    size = "xl",
    color = "black",
    weight,
    className,
    icon,
    iconColor = "default",
  } = props;

  if (!isVisible) {
    return null;
  }
  return (
    <>
      {hasSeparator && <Separator color="border-inside" />}
      <Flex grow={1} innerMargin="sm">
        {icon && (
          <Flex justify="center" align="flex-start" margin={["xs", false, false, false]}>
            <Icon icon={icon} size="xl" color={iconColor} />
          </Flex>
        )}
        <Flex direction="column" innerMargin="sm" className={className} width={12}>
          <Flex align="center" innerMargin="sm">
            <Text size={size} color={color} weight={weight}>
              {label}
            </Text>
          </Flex>
          {children}
        </Flex>
      </Flex>
    </>
  );
});
